import "./servicecard.scss";
import Button from "../../core/button/button";

export interface IServiceCard {
    image:string
    title:string
    body:string
}

const ServiceCard = ({image,title,body}:IServiceCard) => {
    return (
        <div className="Service-Card">
            <div className="Service-Card-Image">
                <img src={image} alt="" className="img-fluid"/>
            </div>
            <div className="Service-Card-Body">
                <h6>{title}</h6>
                <p>{body}</p>
                <Button type={"primary"} action={() => {}} responsive={false}>شروع کنید</Button>
            </div>
        </div>
    );
}

export default ServiceCard